<template>
  <div class="reports-add-jobs">
    <div :class="{'add-desktop-obj': flag}">
      <el-button v-if="flag"
                 style="width: 100%"
                 :disabled="!!disabled || approve"
                 size="small"  :class="['add', {disabled: this.approve}]" :type="isSelect ? 'default' : 'primary'" @click="openDialog"
      >
        <span :class="[{disabled: this.approve}]" class="mob-show-create">{{ isSelect ? 'Сменить Объект' : '+ Выбрать Объект' }}</span>
        <span :class="[{disabled: this.approve}]"  class="desktop-show-create">+ Объект</span>
      </el-button>
      <el-button v-else-if="!approve"
                 style="width: 100% !important;"
                 :disabled="!!disabled || approve"
                 size="small" class="add" :type="isSelect ? 'default' : 'primary'" @click="openDialog"
      >
        <span >{{ isSelect ? 'Сменить Объект' : '+ Выбрать Объект' }}</span>
      </el-button>
    </div>
    <el-dialog append-to-body title="Выбрать объект" :visible.sync="dialogObject">
      <div class="add-jobs" v-loading="loader">
        <div style="margin-bottom: 18px" class="object-back">
          <div v-if="selectParent" @click="backObject()">
            <i class="el-icon-back"></i>
          </div>
          <div>
            <el-switch @change="switchChange" v-model="isObjectList">
            </el-switch>
            <strong>Иерархический вид</strong>
          </div>
          <div v-if="isObjectList && selectParent">
            <div class="circle-back" @click="backToMain">
              <i class="el-icon-arrow-up"></i>
            </div>
          </div>
        </div>
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="jobs-ul">
          <div
            v-if="selectParent"
            @click="save(selectParent, true)"
            class="jobs-li"
          >
            <strong>{{ selectParent.name }}</strong>
          </div>
          <div
            v-show="list.id !== 'all' || !selectParent"
            @click="save(list.id === 'all'? {} : list, list.id === 'all')"
            class="jobs-li" v-for="(list, index) in filteredList" :key="index"
          >
            <span>{{ list.name }}</span>
          </div>


          <div :class="['jobs-li link', {disabled: this.approve}]" v-if="role === 'admin'">
            <router-link to="/dashboard/objects">+ Добавить новый объект</router-link>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _ from 'lodash';
import {filterObjects} from "../../../../utils/filterJobs";
import {getPermission, getPermissionByUser} from "../../../../firestore/permission";
import dayjs from "dayjs";
import {isCache} from "../../../../plugins/firebase";

export default {
  name: 'AddObjects',
  props: ['isSelect', 'confirmDisable', 'disabled', 'approve', 'index', 'flag'],
  data() {
    return {
      search: '',
      dialogObject: false,
      permissionUser: null,
      unit: '',
      loader: true,
      role: 'admin',
      selectParent: null,
      prevParent: [null],
      isObjectList: false,
      list: [],
      form: {
        value: '',
        unit: '',
      },
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },

  async mounted() {
    this.selectParent = null;
    this.prevParent = [null]
    this.isObjectList = this.$store.state.project.object_list

    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || authFirestore.currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), undefined, true);

    if (!this.$store.state.project.version) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, authFirestore.currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id) || null);
    }

    if(this.isObjectList) {
      this.fetchByList();
    } else {
      this.fetchTree();
    }
    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[authFirestore.currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });
  },

  methods: {
    switchChange(flag) {
      if(flag) {
        this.fetchByList()
      } else {
        this.fetchTree()
      }
    },
    backObject() {
      this.selectParent = this.prevParent[this.prevParent.length - 1]
      if(this.prevParent.length > 1) {
        this.prevParent.pop()
        this.prevParent = [...this.prevParent]
      }
      this.fetchByList(this.selectParent ? this.selectParent.id : null);
    },
    backToMain() {
      this.selectParent = null
      this.prevParent = [null]
      this.fetchByList( null);
    },
    fire() {
      if (this.$route.query.version) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id)) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    fetchByList(parentId = null) {
      this.loader = true;
      const result = [];

      this.fire()
        .collection('objects')
        .where('parentId', '==', parentId)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        if (!result.length) {
          let objectName = ''
          this.prevParent.forEach((obj) => {
            if (obj) {
              if(objectName) {
                objectName = objectName + ' > ' + obj.name
              } else {
                objectName =  obj.name

              }
            }
          })


          this.$emit('add-objects', {
            name: objectName ? ( objectName+ ' > ' + this.selectParent.name) : this.selectParent.name,
            id: this.selectParent.id,
          });
          this.close();
        }


        result.push({
          name: 'Без объекта',
          id: 'all'
        })


        this.list = _.orderBy(filterObjects(filterObjects(result, this.permission), this.permissionUser), 'index', ['asc']);
        this.loader = false;
      }).catch((e) => {
        console.error(e)
        this.loader = false;
      });
    },
    fetchTree() {
      this.loader = true;

      const result = [];


      const path = 'OBJECT_' + this.fire().path


      const cache = localStorage.getItem(path);



      if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {
        this.fire()
          .collection('objects')
          .get()
          .then((data) => {
            data.forEach((subDoc) => {
              const data = subDoc.data();

              result.push({
                id: subDoc.id,
                name: data.name,
                objects: data.objects,                code: data.code,


                index: data.index,
                parentId: data.parentId || undefined,
                isParent: data.isParent,
              });
            });
          }).finally(() => {
          // if(isCache) {
          localStorage.setItem(path, JSON.stringify({result, expire: dayjs().add(10, 'minute').unix()}))
          // }

          result.push({
            name: 'Без объекта',
            id: 'all'
          })
          this.list = _.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc']);
          this.loader = false;
        }).catch(() => {
          this.loader = false;
        });
      } else {

        const result = JSON.parse(cache).result
        result.push({
          name: 'Без объекта',
          id: 'all'
        })
        this.list = _.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc']);
        this.loader = false;
      }
    },
    openDialog() {

      if (this.confirmDisable) {
        this.$emit('add-objects', null);
        return this.dialogObject = true;
      }
      if (this.isSelect && this.$route.params.type !== 'TECH' && this.$route.params.type !== 'PROF') {
        this.$confirm('После смены объекта вся введенная информация по работам будет удалена, продолжить?', 'Подтверждение', {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(() => {
          this.selectParent = null;
          this.prevParent = [null]
          if ( this.isObjectList) {
            this.fetchByList()
          }
          this.$emit('add-objects', null);
          this.dialogObject = true;
        });
      } else {
        this.$emit('add-objects', '');
        this.dialogObject = true;
      }
    },
    save(object, isflag) {
      if (this.isObjectList && !isflag) {
        if(this.selectParent) {
          this.prevParent.push(JSON.parse(JSON.stringify(this.selectParent)))
        }
        this.selectParent = object
        this.fetchByList(this.selectParent.id)
      } else {
        this.$emit('add-objects', {
          name: object.name || 'Без объекта',
          index: this.index || 0,
          code: object.code || null,
          id: object.id || null,
        });
        this.close();
      }
    },
    close() {
      this.dialogObject = false;

      if(this.isObjectList) {
        this.backObject()
      }

      // this.fetchByList( null);

      this.clear();
    },
    clear() {
      this.form.value = '';
      this.form.unit = '';
    },
  },
};
</script>

<style lang="scss">

.circle-back {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  border: 1px solid grey;
  display: flex;
  flex-direction: column;
  position: absolute;
  align-items: center;
  justify-content: center;
  right: 20px;
  margin-top: -20px;
  cursor: pointer;
  .el-icon-arrow-up {
    margin-bottom: 2px;
  }
}
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 4px 10px !important;
    width: calc(100% - 20px);
    justify-content: flex-start;
    text-align: left;
    height: auto !important;
    min-height: 48px !important;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    span {
      text-align: left;
    }

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.object-back {
  display: flex;
  align-items: center;
  .el-icon-back {
    width: 50px;
    cursor: pointer;
  }
  i {
    font-size: 22px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/AddObjectsWork.vue